export default __webpack_public_path__ + "static/media/tcsleftbg.eb91450b.webp";